import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.CanvasBasedWindow
import com.kinoshazam.applyStoredAppLanguage
import com.kinoshazam.screens.rootFlow.RootContent
import com.kinoshazam.uiKit.theme.UiKitTheme
import di.initKoin
import kotlinx.browser.window
import org.jetbrains.skiko.wasm.onWasmReady
import org.w3c.dom.events.Event

private fun currentJoinHref(): String? =
    window.location.href.takeIf { href ->
        val path = window.location.pathname
        href.contains("join=") || path.startsWith("/join/")
    }

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    initKoin().koin
    runCatching { applyStoredAppLanguage() }
    onWasmReady {
        CanvasBasedWindow(
            title = "Kinoshka",
            canvasElementId = "ComposeTarget",
        ) {
            var openCount by remember { mutableStateOf(0) }
            var joinHref by remember { mutableStateOf(currentJoinHref()) }
            DisposableEffect(Unit) {
                val onChange: (Event) -> Unit = {
                    currentJoinHref()?.let { href ->
                        joinHref = href
                        openCount += 1
                    }
                }
                window.addEventListener("popstate", onChange)
                window.addEventListener("focus", onChange)
                onDispose {
                    window.removeEventListener("popstate", onChange)
                    window.removeEventListener("focus", onChange)
                }
            }
            val deepLink = joinHref?.let { href ->
                if (openCount == 0) href else "$href#reopen$openCount"
            }
            UiKitTheme {
                RootContent(deepLink = deepLink)
            }
        }
    }
}
